import { useEffect, useState } from "react";
import { fetchCharterRoleCards, type CharterRoleCardsResponse } from "../lib/charterRoleCards";

/**
 * track:charter-owner-only (spec #66091) — the Charter view for members who are
 * not the platform owner: the Charter version and the role cards, read-only.
 */
export function CharterRoleCardsView({ workspaceId }: { workspaceId: string }) {
  const [data, setData] = useState<CharterRoleCardsResponse | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const result = await fetchCharterRoleCards(workspaceId);
        if (!cancelled) setData(result);
      } catch (err: unknown) {
        if (!cancelled) setError(err instanceof Error ? err.message : "Failed to load role cards.");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [workspaceId]);

  if (error) return <div style={{ padding: 24, color: "var(--tag-blocker)", fontSize: 13 }}>{error}</div>;
  if (!data) return <div style={{ padding: 24, color: "var(--text3)", fontSize: 13 }}>Loading role cards…</div>;

  return (
    <div style={{ padding: "16px 24px" }}>
      <div style={{ fontSize: 15, fontWeight: 600, color: "var(--text)" }}>
        Charter{data.version !== null ? ` v${data.version}` : ""}
      </div>
      <div style={{ fontSize: 12.5, color: "var(--text3)", margin: "4px 0 12px" }}>
        Relay's Charter is shown to you and your AI partners as role cards: the short rules for each job. The full Charter is kept by Relay.
      </div>
      {data.cards.length === 0 && <div style={{ fontSize: 13, color: "var(--text3)" }}>No role cards are set yet.</div>}
      {data.cards.map((c) => (
        <details key={c.role} style={{ marginBottom: 8 }}>
          <summary style={{ cursor: "pointer", fontSize: 13.5, color: "var(--text)" }}>{c.role}</summary>
          <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", fontFamily: "var(--mono)", fontSize: 12, color: "var(--text)", margin: "8px 0 0" }}>{c.text}</pre>
        </details>
      ))}
    </div>
  );
}
